
$models.emails = {
	
	getItem : function($emailid, $callback) {
		$models.all.getDataFromAPI('emails/'+$emailid+'.json', {return_body:'prefer_html'}, function($email) {
			$email = $models.emails.handleInvalidEmailHeaders($email);
			$callback($email);
			
		}, 'An error occurred whilst retrieving this email', '', '', true);
	},
	
	getList : function($params, $callback) {
		$models.all.getDataFromAPI('emails.json', $params, function($data) {
			// handle emails with FROM headers in weird formats or when FROM header is NULL...
			jQuery.each($data.emails, function($key, $email) {
				$data.emails[$key] = $models.emails.handleInvalidEmailHeaders($email);
			});
			$callback($data);
		}, 'Unable to load the list of emails at this time');
	},
	
	getSize : function($callback) {
		$models.all.getDataFromAPI('emails/count.json', '', function($data) {
			$callback($data.total_result_count);
		}, 'Unable to retrieve number of emails within your account');
	},
	
	deleteItem : function($emailid, $callback) {
		$models.all.getDataFromAPI('emails/'+$emailid+'.json', '', $callback, 'An error occurred whilst removing this email', 'DELETE');
	},
	
	getItemInvolvingYou : function($email) {
		$email = $models.emails.handleInvalidEmailHeaders($email);
		if ($email.from.email == $models.login.getEmailAddress()) { return true; }
		jQuery.each($email.to, function($key, $toAddress) {
			if ($toAddress.email == $models.login.getEmailAddress()) { return true; }
		});
		jQuery.each($email.cc, function($key, $toAddress) {
			if ($toAddress.email == $models.login.getEmailAddress()) { return true; }
		});
		return false;
	},
	
	setItem : function($emailid, $tags, $callback) {
		$data = {email: {tags: $tags}};
		if ($emailid > 0) {
			$models.all.getDataFromAPI('emails/'+$emailid+'.json', $data, $callback, 'An error occurred whilst saving changes to the email', 'PUT');
		} else {
			console.error('Unable to call setItem() on a non-existent email');
		}
	},
	
	handleInvalidEmailHeaders : function($email) {
		// handle NULL in the FROM header
		if (!$email.from) {
			$email.from = { display_name: '(No sender)', email: '' };
		}
		// apply string escaping to from display name
		if ($email.from && $email.from.display_name) {
			$email.from.display_name = $soupmail.string.basicHtmlEscape($email.from.display_name);
		}
		return $email;
	}
	
};



// WEBPACK FOOTER //
// ./src/js/models/emails.js